import { UC_CANDIDATE_OUTREACH } from "@/constants/constants";
import { z } from "zod";
// No import needed - using string literals

export const campaignDtoSchema = z.object({
  id: z.coerce.number().optional(),
  agentType: z.string().min(1, "Agent Type is required").max(100, "Max 100 characters"),
  name: z.string().min(1, "Campaign is required").max(1000, "Max 1000 characters"),
  language: z.string().min(1, "Language is required"),
  programId: z.string().optional(),
  senderPersonaId: z.coerce.number().optional(),
  recipientPersonaId: z.coerce.number().optional(),
  emailSubjectTemplate: z.string().max(500, "Maximum 500 characters allowed").optional(),
  llmModelId: z.coerce.number(),
  temperature: z.preprocess(
    (val) => {
      if (val === "" || val === null || val === undefined) {
        return undefined;
      }
      return Number(val);
    },
    z.number({ message: "Temperature is required" })
      .min(0, "Temperature must be between 0 and 1")
      .max(1, "Temperature must be between 0 and 1")
      .refine((val) => {
        const rounded = Math.round(val * 10) / 10;
        return Math.abs(val - rounded) < 0.0001;
      }, "Temperature must have at most 1 decimal place")
  ),
  maxQuestions: z.coerce.number().min(1, "Must be at least 1").optional(),
  maxFollowupQuestions: z.coerce.number().min(1, "Must be at least 1").optional(),
  promptInstructions: z.string().max(2000, "Maximum 2000 characters allowed").optional(),
  quietHours: z.boolean().optional(),
  holidayPreferences: z.boolean().optional(),
  weekendPreferences: z.boolean().optional(),
  preflightValidation: z.boolean().optional(),
  emailEnabled: z.boolean().optional(),
  smsEnabled: z.boolean().optional(),
  whatsappEnabled: z.boolean().optional(),
}).refine(
  (data) => {
    // Sender persona is required when agent type is selected
    if (data.agentType) {
      return data.senderPersonaId !== undefined && data.senderPersonaId !== null;
    }
    return true;
  },
  {
    message: "Sender Persona is required when Agent Type is selected",
    path: ["senderPersonaId"],
  }
).refine(
  (data) => {
    if (data.agentType === UC_CANDIDATE_OUTREACH) {
      return data.maxQuestions !== undefined && data.maxQuestions !== null;
    }
    return true;
  },
  {
    message: "Maximum Questions is required for CANDIDATE_OUTREACH agent type",
    path: ["maxQuestions"],
  }
).refine(
  (data) => {
    if (data.agentType === UC_CANDIDATE_OUTREACH) {
      return data.maxFollowupQuestions !== undefined && data.maxFollowupQuestions !== null;
    }
    return true;
  },
  {
    message: "Maximum Follow-up Questions is required for CANDIDATE_OUTREACH agent type",
    path: ["maxFollowupQuestions"],
  }
).refine(
  (data) => {
    // At least one communication channel must be enabled
    return data.emailEnabled === true || data.smsEnabled === true || data.whatsappEnabled === true;
  },
  {
    message: "At least one communication channel (Email, SMS, or WhatsApp) must be enabled",
    path: ["emailEnabled"],
  }
);